import React from 'react'
import PropTypes from 'prop-types'
import useCase from '../hooks/use-case'

function WhenCaseIsNot (props) {
  const caseValue = useCase()

  if (caseValue !== props.value) {
    return props.children
  }

  return null
}

WhenCaseIsNot.defaultProps = {
  value: null
}

WhenCaseIsNot.propTypes = {
  value: PropTypes.any.isRequired
}

export default WhenCaseIsNot
